export default __webpack_public_path__ + "static/075-15d0f8bd1e080982e63a8cc1e6006ada.jpg";